/* =========================================================
 * SSR.js
 * サーバーサイドレンダリングに関するutilをここに記述します。
========================================================= */

export const canUseDOM = () => {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}